import { render, staticRenderFns } from "./IbxCardMetaBase.vue?vue&type=template&id=b99c3f02"
import script from "./IbxCardMetaBase.vue?vue&type=script&lang=ts"
export * from "./IbxCardMetaBase.vue?vue&type=script&lang=ts"
import style0 from "./IbxCardMetaBase.vue?vue&type=style&index=0&id=b99c3f02&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports